import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Instagram, Linkedin, Youtube } from "lucide-react";

const footerLinks = {
  "Find Partners": [
    { label: "Tennis Partners", href: "/sports/tennis" },
    { label: "Pickleball Partners", href: "/sports/pickleball" },
    { label: "Golf Partners", href: "/sports/golf" },
    { label: "Table Tennis", href: "/sports/table-tennis" },
    { label: "All Sports", href: "/sports" },
  ],
  "Locations": [
    { label: "Fort Worth, TX", href: "/us/texas/fort-worth" },
    { label: "Dallas, TX", href: "/us/texas/dallas" },
    { label: "Austin, TX", href: "/us/texas/austin" },
    { label: "Denver, CO", href: "/us/colorado/denver" },
    { label: "Browse All Cities", href: "/find-partners" },
  ],
  "Platform": [
    { label: "How It Works", href: "/how-it-works" },
    { label: "Pricing", href: "/pricing" },
    { label: "For Clubs", href: "/clubs" },
    { label: "Corporate Leagues", href: "/leagues" },
    { label: "Venues", href: "/venues" },
  ],
  "Legal": [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
    { label: "Safety Center", href: "/safety" },
    { label: "Community Guidelines", href: "/community" },
    { label: "Contact Us", href: "/contact" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-brand-navy border-t border-brand-navy/20 dark-section" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-8">
          {/* Brand column */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center mb-5" data-testid="footer-logo">
              <div className="bg-white rounded-xl p-2 inline-flex">
                <img
                  src="/logo.png"
                  alt="ActivitySports"
                  className="h-12 w-auto object-contain"
                />
              </div>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed mb-5">
              The trusted way to find the right sports partner — anywhere in the world.
              Match by skill, book the session, not just start a chat.
            </p>
            <div className="flex gap-3">
              {[
                { Icon: Twitter, name: "Twitter" },
                { Icon: Instagram, name: "Instagram" },
                { Icon: Linkedin, name: "LinkedIn" },
                { Icon: Youtube, name: "YouTube" },
              ].map(({ Icon, name }) => (
                <a
                  key={name}
                  href="#"
                  aria-label={`ActivitySports on ${name}`}
                  className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center text-white/70 hover:text-brand-green-bright hover:bg-white/20 transition-colors"
                >
                  <Icon size={14} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              {/* h2, not h4. The footer is a landmark sibling of <main>, so its
                  columns are peer-level sections. As h4 they skipped straight
                  from the preceding page heading - an h1 to h4 jump on pages
                  whose last heading was the h1, which axe reports as
                  heading-order. Column titles are also visually styled, so the
                  level change has no visual effect. */}
              <h2 className="text-xs font-bold tracking-widest uppercase text-white/70 mb-3">{section}</h2>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith("mailto:") ? (
                      <a
                        href={link.href}
                        className="text-sm text-white/70 hover:text-brand-green-bright transition-colors"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-white/70 hover:text-brand-green-bright transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Kosansh Solutions Inc · ActivitySports.com · All rights reserved
          </p>
          <p className="text-xs text-white/70">
            Fort Worth, TX · <a href="mailto:techieroshan@gmail.com" className="hover:text-white/60 transition-colors">techieroshan@gmail.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
